// extracted by mini-css-extract-plugin
export default {"section":"CurriculumSection_section__MfPrA","title":"CurriculumSection_title__84MGA","grid":"CurriculumSection_grid__X7Dd9"};